import { __decorate, __extends } from "tslib";
import * as React from 'react';
import { withTranslation } from '../../component-decorators/with-translation';
import { SupportModalSuccessNotification } from './support-app/support-app-success-notification';
import { SupportModalFailureNotification } from './support-app/support-app-failure-notification';
export var NotificationNames;
(function (NotificationNames) {
    NotificationNames["NONE"] = "none";
    NotificationNames["SUPPORT_SUCCESS"] = "supportSuccess";
    NotificationNames["SUPPORT_FAILURE"] = "supportFailure";
})(NotificationNames || (NotificationNames = {}));
var Notifications = /** @class */ (function (_super) {
    __extends(Notifications, _super);
    function Notifications() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Notifications.prototype.render = function () {
        var openNotificationName = this.props.openNotificationName;
        return (React.createElement(React.Fragment, null,
            React.createElement(SupportModalSuccessNotification, { show: openNotificationName === NotificationNames.SUPPORT_SUCCESS }),
            React.createElement(SupportModalFailureNotification, { show: openNotificationName === NotificationNames.SUPPORT_FAILURE })));
    };
    Notifications = __decorate([
        withTranslation
    ], Notifications);
    return Notifications;
}(React.Component));
export { Notifications };
//# sourceMappingURL=notifications.js.map